<template>
  <div>
    <div class="doorplate">
      <span
        class="to-session"
        @click="$emit('leaveChatRoom')"
        title="返回会话列表"
        ><i class="el-icon-back"></i
      ></span>
      <p class="chat-user-name">
        <span :class="initChatClass" @click="initUserLink">{{
          chatUser.selToName
        }}</span>
      </p>
    </div>
    <div class="content">
      <div class="message-list" ref="message-list" @scroll="this.onScroll">
        <div class="more" v-if="!isCompleted">
          <el-button
            type="text"
            @click="
              $store.dispatch(
                'getMessageList',
                currentConversation.conversationID
              )
            "
          >
            查看更多
          </el-button>
        </div>
        <div class="no-more" v-else>没有更多了</div>
        <MessageItem
          v-for="message in currentMessageList"
          :key="message.ID"
          :message="message"
        />
      </div>
      <div
        v-show="isShowScrollButtomTips"
        class="newMessageTips"
        @click="scrollMessageListToButtom"
      >
        回到最新位置
      </div>
    </div>
    <div class="footer" v-if="showMessageSendBox">
      <MessageSendBox />
    </div>

    <ImagePreviewer />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MessageItem from "./message/message-item";
import MessageSendBox from "./message/message-send-box";
import ImagePreviewer from "./message/image-previewer";
export default {
  name: "chat-room",
  components: {
    MessageItem,
    MessageSendBox,
    ImagePreviewer,
  },
  data() {
    return {
      isShowScrollButtomTips: false,
      preScrollHeight: 0,
      showConversationProfile: false,
      timeout: "",
    };
  },
  computed: {
    ...mapState({
      currentMessageList: (state) => state.currentConversation.messageList,
      currentConversation: (state) => state.currentConversation,
      isCompleted: (state) => state.currentConversation.isCompleted,
      chatUser: (state) => state.currentChat,
    }),
    showMessageSendBox() {
      return this.currentConversation.type !== this.TIM.TYPES.CONV_SYSTEM;
    },
    initChatClass() {
      // console.log(this.chatUser)
      if (this.chatUser) {
        if (this.chatUser.selType == "C2C") {
          return "double-chat";
        }
      } else {
        return "group-chat";
      }
    },
  },
  mounted() {
    this.$bus.$on("image-loaded", this.onImageLoaded);
    this.$bus.$on("scroll-bottom", this.scrollMessageListToButtom);
    if (this.currentConversation.userId === "@TIM#SYSTEM") {
      return false;
    }
  },
  methods: {
    onScroll({ target: { scrollTop } }) {
      let messageListNode = this.$refs["message-list"];
      if (!messageListNode) {
        return;
      }
      if (
        this.preScrollHeight - messageListNode.clientHeight - scrollTop <
        20
      ) {
        this.isShowScrollButtomTips = false;
      }
    },
    // 如果滚到底部就保持在底部，否则提示是否要滚到底部
    keepMessageListOnButtom() {
      let messageListNode = this.$refs["message-list"];
      if (!messageListNode) {
        return;
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (
        this.preScrollHeight -
          messageListNode.clientHeight -
          messageListNode.scrollTop <
        20
      ) {
        this.$nextTick(() => {
          messageListNode.scrollTop = messageListNode.scrollHeight;
        });
        this.isShowScrollButtomTips = false;
      } else {
        this.isShowScrollButtomTips = true;
      }
      this.preScrollHeight = messageListNode.scrollHeight;
    },
    // 直接滚到底部
    scrollMessageListToButtom() {
      this.$nextTick(() => {
        let messageListNode = this.$refs["message-list"];
        if (!messageListNode) {
          return;
        }
        messageListNode.scrollTop = messageListNode.scrollHeight;
        this.preScrollHeight = messageListNode.scrollHeight;

        this.isShowScrollButtomTips = false;
      });
    },
    showMore() {
      this.showConversationProfile = !this.showConversationProfile;
    },
    onImageLoaded() {
      this.keepMessageListOnButtom();
    },
    initUserLink() {
      // console.log(this.chatUser)
      if (this.chatUser) {
        if (this.chatUser.selType == "C2C") {
          this.$router.push({
            path: "/feed",
            query: {
              id: this.chatUser.selToID,
            },
          });
        }
      }
    },
  },
  watch: {
    currentMessageList(list) {
      let scrollBottom = this.currentConversation.scrollBottom;
      if (list.length != 0 && scrollBottom) {
        this.scrollMessageListToButtom();
      }
      this.keepMessageListOnButtom();
    },
  },
};
</script>
<style scoped>
.doorplate {
  position: relative;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #fff;
}

.content {
  position: relative;
  border: 1px solid #e7e7e7;
}

/* ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
} */

/* ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: rgba(0,0,0,.1);
} */

/* ::-webkit-scrollbar-track {
    border-radius: 10px;
} */

.doorplate .to-session {
  position: absolute;
  top: 0;
  left: 6px;
  width: 50px;
  font-size: 22px;
  cursor: pointer;
}

.message-list {
  width: 100%;
  height: 500px;
  box-sizing: border-box;
  overflow-y: scroll;
  padding: 0 20px;
  background-color: #f2f2f2;
}

.message-list .no-more {
  color: #a5b5c1;
  padding: 10px 10px;
}

.message-list .more,
.message-list .no-more {
  display: flex;
  justify-content: center;
  font-size: 12px;
}

.content .newMessageTips {
  position: absolute;
  cursor: pointer;
  padding: 5px;
  width: 120px;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 5px;
  font-size: 12px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #e9eaec;
  background-color: #fff;
  color: #2d8cf0;
}

.content_wrap {
  margin: 5px 0;
}

.left_msg {
  display: flex;
}

.right_msg {
  display: flex;
  justify-content: flex-end;
}

.left_msg .user-avatar {
  width: 45px;
  height: 45px;
}

.right_msg .user-avatar {
  width: 45px;
  height: 45px;
}

.footer {
  height: 200px;
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-color: #e7e7e7;
}

.chat-user-name {
  font-size: 16px;
}

.double-chat {
  color: #1a70db;
  cursor: pointer;
}
</style>
